// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"483":"5071d60d","787":"ea568286"}[chunkId] + ".chunk.js";
};